import React from 'react';
import Options from './partials/options';
import fakeAuth from '../../../fakeAuth';

class Dashboard extends React.Component {
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    render() {        
        return <section className="white d-flex flex-column justify-content-center h-100">
            <Options onLogout={this.logout} className="h-100 align-self-center" />
        </section>
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/private/dashboard/index.js